module.exports = __webpack_public_path__ + "img/cert.cc9d07dc.png";